export default __webpack_public_path__ + "static/media/0268.242e34d9.jpg";